'use strict';

angular.module('ecrd')
    .controller('RulesActionCreateQueriesController', ['$scope', 'gettextCatalog', function($scope, gettextCatalog) {
            var vm = this;

            if (Array.isArray($scope.ngDialogData.queries)) {
                vm.queries = $scope.ngDialogData.queries.map(function(query) {
                    if (query.text == 'field-required-value-not-specified') {
                        query.text = gettextCatalog.getString('El campo es de obligado cumplimiento pero no se ha especificado ningún valor');
                    }
                    return query;
                });
            } else {
                vm.queries = [];
            }

            vm.close = function() {
                $scope.closeThisDialog('$dismissed');
            };

            vm.continue = function() {
                $scope.closeThisDialog('$continue');
            };
    }]);
